import { ReactNode, useEffect, useRef, useState } from 'react';

import { SsrApiDataContext } from './SsrApiDataContext';

type Props = {
  ssrApiData: Record<string, unknown>;
  children: ReactNode;
};

/**
 * SsrApiDataContext that cleans erases the ssrApiData after the client is loaded (useEffect)
 *
 * The data gets erased to prevent the user from seeing stale data after going to another page,
 * then going back to the one he started at.
 */
export function SsrApiDataContextSelfErasingProvider({
  ssrApiData,
  children,
}: Props) {
  const [selfErasingData, setSelfErasingData] = useState(ssrApiData);
  const hasDataRef = useRef(Object.keys(selfErasingData).length > 0);

  useEffect(() => {
    if (!hasDataRef.current) return;
    setSelfErasingData({});
  }, []);

  return (
    <SsrApiDataContext.Provider value={selfErasingData}>
      {children}
    </SsrApiDataContext.Provider>
  );
}
